const app = {
    state:{
    },
}
export default app


// WEBPACK FOOTER //
// ./src/store/modules/api.js